import { useState } from 'react'
import { supabase } from '../supabase'

function Auth() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [username, setUsername] = useState('')
  const [fullName, setFullName] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [mode, setMode] = useState('signin')
  const [success, setSuccess] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    setSuccess(null)

    if (mode === 'signin') {
      const { error } = await supabase.auth.signInWithPassword({ email, password })
      if (error) setError(error.message)
    } else {
      if (!username.trim()) {
        setError('Please choose a username.')
        setLoading(false)
        return
      }

      // Check username is not already taken
      const { data: existing } = await supabase
        .from('profiles')
        .select('id')
        .eq('username', username.trim().toLowerCase())
        .single()

      if (existing) {
        setError('That username is already taken. Please choose another.')
        setLoading(false)
        return
      }

      const { data, error: signUpError } = await supabase.auth.signUp({ email, password })
      if (signUpError) {
        setError(signUpError.message)
        setLoading(false)
        return
      }

      // Create profile record
      if (data?.user) {
        const { error: profileError } = await supabase
          .from('profiles')
          .insert([{
            id: data.user.id,
            username: username.trim().toLowerCase(),
            full_name: fullName.trim() || null
          }])
        if (profileError) {
          setError('Account created but profile save failed. Please contact support.')
          setLoading(false)
          return
        }
      }

      setSuccess('Account created. Please check your email to confirm your account.')
    }
    setLoading(false)
  }

  return (
    <div className="auth-page">
      <div className="auth-left">
        <div className="auth-brand">
          <div className="auth-brand__name">CADENCE</div>
          <div className="auth-brand__sub">by Captus</div>
        </div>
        <h1 className="auth-headline">
          Bid management built for Government and Defence.
        </h1>
        <p className="auth-body">
          AI-powered opportunity intelligence, structured qualification,
          bid tracking, and response planning — in one platform built
          on fifteen years of sector expertise.
        </p>
      </div>

      <div className="auth-right">
        <div className="auth-form">
          <h2>{mode === 'signin' ? 'Sign in to Cadence' : 'Create your account'}</h2>
          <p>
            {mode === 'signin'
              ? 'Enter your credentials to access your bid workspace.'
              : 'Set up your Cadence account to get started.'}
          </p>

          {error && <div className="error-msg">{error}</div>}
          {success && <div className="success-msg">{success}</div>}

          <form onSubmit={handleSubmit}>
            {mode === 'signup' && (
              <>
                <div className="form-group">
                  <label>Full Name (optional)</label>
                  <input
                    type="text"
                    value={fullName}
                    onChange={e => setFullName(e.target.value)}
                    placeholder="e.g. Jonathan Phillpotts"
                  />
                </div>
                <div className="form-group">
                  <label>Username *</label>
                  <input
                    type="text"
                    value={username}
                    onChange={e => setUsername(e.target.value.replace(/\s/g, '').toLowerCase())}
                    placeholder="e.g. jonathanp"
                  />
                  <div style={{ fontSize: '0.75rem', color: 'var(--slate)', marginTop: '4px' }}>
                    Lowercase letters and numbers only. This is how you will appear in Cadence.
                  </div>
                </div>
              </>
            )}
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Your password"
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn--primary btn--full"
              disabled={loading}
            >
              {loading
                ? 'Please wait...'
                : mode === 'signin' ? 'Sign In' : 'Create Account'}
            </button>
          </form>

          <p style={{
            marginTop: '24px', fontSize: '0.875rem',
            color: 'var(--slate)', textAlign: 'center'
          }}>
            {mode === 'signin' ? "Don't have an account? " : "Already have an account? "}
            <button
              onClick={() => {
                setMode(mode === 'signin' ? 'signup' : 'signin')
                setError(null)
                setSuccess(null)
              }}
              style={{
                background: 'none', border: 'none',
                color: 'var(--green)', fontWeight: 600,
                cursor: 'pointer', fontSize: '0.875rem'
              }}
            >
              {mode === 'signin' ? 'Create account' : 'Sign in'}
            </button>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Auth